import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BdbRequestService } from './bdb-request.service';
import { RequestInfo } from '../models/request-info.model';
import {ResponseFromFetch} from '../models/response-from-fetch.model';

@Injectable()
export class BdbTokenAuthService {

  constructor(private readonly bdbRequest: BdbRequestService) { }

  validateAuthToken(documentType: string, documentNumber: string, token: string,
                    uuidAuthentication: string, ignoreFirstAuthMethod: boolean): Promise<ResponseFromFetch> {
    if (!(documentType && documentNumber)) {
      throw new Error('documentType and documentNumber parameters are required.');
    }
    const urlValidateToken = environment.authenticatorEndpoint + '/authentication/token';
    const body = {
      documentNumber,
      documentType,
      otp: token,
      uuidAuth: uuidAuthentication,
      ignoreFirstAuthMethod
    };
    const requestInfo: RequestInfo = {
      body
    };
    return this.bdbRequest.requestPostWithOldHeaders(urlValidateToken, requestInfo);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-token-auth.service.ts